/* Shazory · Build Your Set · v5.2 JS · Permanent centered ladder ticker (no dismiss) */
(function(){
  'use strict';

  var PLAN_KEY = 'shazoryBundlePlan';

  // Clean up any old dismissal flag from previous v5.1 in case it's still in sessionStorage.
  try { sessionStorage.removeItem('shz_ticker_dismissed'); } catch(e){}

  function showError(msg, detail){
    var wrap = document.getElementById('studiosWrap');
    if (!wrap) return;
    var box = document.createElement('div');
    box.style.cssText = 'background:#3a1a1a;border:1px solid #c9a84c;color:#E8E1F0;padding:24px;margin:24px;border-radius:6px;font-family:Jost,sans-serif;font-size:14px;line-height:1.5;';
    box.innerHTML = '<strong style="color:#C9A84C;display:block;margin-bottom:8px;font-size:16px;">Build Your Set — Render Error</strong>' + msg + (detail?'<pre style="margin-top:12px;padding:12px;background:#0F1437;border-radius:4px;overflow:auto;font-size:12px;color:#E8D89B;">'+detail+'</pre>':'');
    wrap.appendChild(box);
  }

  var DATA;
  try {
    var raw = document.getElementById('shazoryBundleData');
    if (!raw) { showError('Data script tag #shazoryBundleData not found in DOM.'); return; }
    DATA = JSON.parse(raw.textContent);
  } catch(e){
    showError('Failed to parse bundle data JSON.', e.message);
    return;
  }
  if (!DATA || !DATA.products || !DATA.products.length){
    showError('Bundle data loaded but contains no products.');
    return;
  }

  var state = { activeRel: 'all', activeStudio: null, set: {} };

  var STUDIO_MAP = {};
  DATA.studios.forEach(function(s){ STUDIO_MAP[s.id] = s; });
  var REL_MAP = {};
  DATA.relationships.forEach(function(r){ REL_MAP[r.id] = r; });

  function gaEvent(name, params){ try { if (typeof gtag === 'function') gtag('event', name, params || {}); } catch(e) {} }
  function escapeHtml(s){ if (s == null) return ''; return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function escapeAttr(s){ return escapeHtml(s); }
  function fmtMoney(n){ var num = parseFloat(n); if (isNaN(num)) return '$0'; return '$' + num.toFixed(2).replace(/\.00$/, ''); }
  function getQty(){ var t=0; Object.keys(state.set).forEach(function(k){ t += state.set[k].qty; }); return t; }
  function getSubtotal(){
    var t = 0;
    Object.keys(state.set).forEach(function(k){
      var entry = state.set[k];
      var prod = DATA.products.find(function(p){ return String(p.id) === k; });
      if (!prod) return;
      var v = prod.variants.find(function(vr){ return vr.id === entry.variantId; });
      var price = v ? parseFloat(v.price) : parseFloat(prod.minPrice);
      t += price * entry.qty;
    });
    return t;
  }
  function getDiscountAmount(){
    var q = getQty();
    var amount = 0;
    DATA.discountTiers.forEach(function(tier){ if (q >= tier.min) amount = tier.amount; });
    return amount;
  }
  function filterProductsForRel(relId){
    if (relId === 'all') return DATA.products.slice();
    return DATA.products.filter(function(p){ return p.relationships && p.relationships.indexOf(relId) !== -1; });
  }

  function renderStudioNav(){
    var nav = document.getElementById('studioNav');
    if (!nav) return;
    nav.innerHTML = '';
    var rel = REL_MAP[state.activeRel] || REL_MAP.all;
    var orderedStudioIds = rel.studioOrder || [];
    var products = filterProductsForRel(state.activeRel);
    var counts = {};
    products.forEach(function(p){ counts[p.studio] = (counts[p.studio] || 0) + 1; });
    orderedStudioIds.forEach(function(sid){
      if (!counts[sid]) return;
      var s = STUDIO_MAP[sid];
      if (!s) return;
      var chip = document.createElement('button');
      chip.className = 'studio-chip' + (state.activeStudio === sid ? ' active' : '');
      chip.type = 'button';
      chip.innerHTML = s.label + '<span class="studio-chip-count">(' + counts[sid] + ')</span>';
      chip.onclick = function(){
        var target = document.getElementById('studio-section-' + sid);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          state.activeStudio = sid;
          renderStudioNav();
        }
      };
      nav.appendChild(chip);
    });
  }

  function buildCard(product){
    var card = document.createElement('div');
    card.className = 'product-card';
    card.setAttribute('data-product-id', product.id);
    var inSet = !!state.set[product.id];
    if (inSet) card.classList.add('in-set');
    var img = product.image || '';
    var priceHTML = product.hasSizes
      ? '<span class="product-card-price-from">from</span>' + fmtMoney(product.minPrice)
      : fmtMoney(product.minPrice);
    var btnHTML;
    if (inSet) {
      btnHTML = '<div class="qty-stepper">' +
        '<button class="qty-btn qty-minus" type="button" aria-label="Decrease">−</button>' +
        '<div class="qty-count">' + state.set[product.id].qty + ' in set</div>' +
        '<button class="qty-btn qty-plus" type="button" aria-label="Increase">+</button>' +
        '</div>';
    } else {
      btnHTML = '<button class="product-card-btn" type="button">Add to Set</button>';
    }
    card.innerHTML =
      '<div class="product-card-img-wrap">' +
        '<div class="product-card-badge">In Set</div>' +
        (img ? '<img class="product-card-img" src="' + img + '" alt="' + escapeAttr(product.title) + '" loading="lazy">' : '') +
      '</div>' +
      '<div class="product-card-body">' +
        '<h3 class="product-card-title">' + escapeHtml(product.title) + '</h3>' +
        '<div class="product-card-price">' + priceHTML + '</div>' +
        btnHTML +
      '</div>';
    if (inSet) {
      card.querySelector('.qty-minus').onclick = function(e){ e.stopPropagation(); changeQty(product.id, -1); };
      card.querySelector('.qty-plus').onclick = function(e){ e.stopPropagation(); changeQty(product.id, +1); };
    } else {
      card.onclick = function(){ onCardClick(product); };
    }
    return card;
  }

  function changeQty(productId, delta){
    var entry = state.set[productId];
    if (!entry) return;
    entry.qty += delta;
    if (entry.qty <= 0) delete state.set[productId];
    renderAll();
  }
  function onCardClick(product){
    if (product.hasSizes && product.variants.length > 1) openSizeSheet(product);
    else {
      state.set[product.id] = { variantId: product.variants[0].id, qty: 1 };
      checkTierReveal();
      renderAll();
    }
  }

  function openSizeSheet(product){
    var sheet = document.getElementById('sizeSheet');
    var backdrop = document.getElementById('sizeBackdrop');
    var optsHTML = product.variants.filter(function(v){ return v.available; }).map(function(v){
      return '<button class="size-option" type="button" data-variant="' + v.id + '">' +
             '<span class="size-option-name">' + escapeHtml(v.title) + '</span>' +
             '<span class="size-option-price">' + fmtMoney(v.price) + '</span>' +
             '</button>';
    }).join('');
    sheet.innerHTML =
      '<h3 class="size-sheet-title">' + escapeHtml(product.title) + '</h3>' +
      '<p class="size-sheet-sub">Choose your size.</p>' +
      '<div class="size-options">' + optsHTML + '</div>' +
      '<button class="size-sheet-cancel" type="button">Cancel</button>';
    sheet.querySelectorAll('.size-option').forEach(function(btn){
      btn.onclick = function(){
        var vid = parseInt(btn.getAttribute('data-variant'),10);
        state.set[product.id] = { variantId: vid, qty: 1 };
        closeSizeSheet();
        checkTierReveal();
        renderAll();
      };
    });
    sheet.querySelector('.size-sheet-cancel').onclick = closeSizeSheet;
    backdrop.onclick = closeSizeSheet;
    sheet.classList.add('show');
    backdrop.classList.add('show');
  }
  function closeSizeSheet(){
    document.getElementById('sizeSheet').classList.remove('show');
    document.getElementById('sizeBackdrop').classList.remove('show');
  }

  var lastTier = 0;
  function checkTierReveal(){
    var amount = getDiscountAmount();
    if (amount > lastTier) {
      var subtotal = getSubtotal();
      var saved = amount;
      var reveal = document.getElementById('tierReveal');
      document.getElementById('tierRevealPct').textContent = '$' + amount;
      document.getElementById('tierRevealSub').textContent = "You're saving " + fmtMoney(saved);
      reveal.classList.add('show');
      setTimeout(function(){ reveal.classList.remove('show'); }, 1800);
    }
    lastTier = amount;
  }

  function buildCarousel(cards){
    var wrap = document.createElement('div');
    wrap.className = 'carousel';
    var trackWrap = document.createElement('div');
    trackWrap.className = 'carousel-track-wrap at-start';
    var track = document.createElement('div');
    track.className = 'carousel-track';
    cards.forEach(function(c){ track.appendChild(c); });
    trackWrap.appendChild(track);
    var prev = document.createElement('button');
    prev.className = 'carousel-arrow prev'; prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous'); prev.innerHTML = '‹';
    var next = document.createElement('button');
    next.className = 'carousel-arrow next'; next.type = 'button';
    next.setAttribute('aria-label', 'Next'); next.innerHTML = '›';
    function getScrollAmount(){
      var firstCard = track.querySelector('.product-card');
      if (!firstCard) return 300;
      var rect = firstCard.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(track).gap) || 16;
      var cardsVisible = Math.max(1, Math.round(track.clientWidth / (rect.width + gap)));
      return (rect.width + gap) * cardsVisible;
    }
    prev.onclick = function(){ track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' }); };
    next.onclick = function(){ track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' }); };
    function updateArrowState(){
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;
      trackWrap.classList.toggle('at-start', atStart);
      trackWrap.classList.toggle('at-end', atEnd);
      prev.disabled = atStart;
      next.disabled = atEnd;
      if (maxScroll <= 4) { prev.style.display = 'none'; next.style.display = 'none'; }
    }
    track.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    setTimeout(updateArrowState, 0);
    wrap.appendChild(trackWrap);
    wrap.appendChild(prev);
    wrap.appendChild(next);
    return wrap;
  }

  function renderStudios(){
    var wrap = document.getElementById('studiosWrap');
    if (!wrap) return;
    wrap.innerHTML = '';
    var rel = REL_MAP[state.activeRel] || REL_MAP.all;
    var orderedStudioIds = rel.studioOrder || [];
    var products = filterProductsForRel(state.activeRel);
    if (!products.length) {
      wrap.innerHTML = '<div style="padding:80px 24px;text-align:center;color:#E8E1F0;font-family:Jost,sans-serif"><h3 style="font-family:Cormorant Garamond,serif;font-size:24px;font-weight:400;color:#E8D89B;margin-bottom:12px">No pieces in this view yet.</h3></div>';
      return;
    }
    var grouped = {};
    products.forEach(function(p){ if (!grouped[p.studio]) grouped[p.studio] = []; grouped[p.studio].push(p); });
    var TIER_ORDER = { hero: 0, practical: 1, lifestyle: 2, filler: 3 };
    Object.keys(grouped).forEach(function(sid){
      grouped[sid].sort(function(a,b){ return (TIER_ORDER[a.tier]||9) - (TIER_ORDER[b.tier]||9); });
    });
    orderedStudioIds.forEach(function(sid){
      var items = grouped[sid];
      if (!items || !items.length) return;
      var s = STUDIO_MAP[sid];
      if (!s) return;
      var section = document.createElement('section');
      section.className = 'studio-section';
      section.id = 'studio-section-' + sid;
      var head = document.createElement('div');
      head.className = 'studio-section-head';
      head.innerHTML = '<h2 class="studio-section-title">' + s.label + '</h2>' +
                       '<span class="studio-section-count">' + items.length + ' ' + (items.length === 1 ? 'piece' : 'pieces') + '</span>';
      section.appendChild(head);
      var cards = items.map(buildCard);
      var carousel = buildCarousel(cards);
      section.appendChild(carousel);
      wrap.appendChild(section);
    });
  }

  function renderContextBand(){
    var band = document.getElementById('contextBand');
    if (!band) return;
    var rel = REL_MAP[state.activeRel] || REL_MAP.all;
    var products = filterProductsForRel(state.activeRel);
    band.innerHTML =
      '<p class="context-eyebrow">' + escapeHtml(rel.label) + '</p>' +
      '<h2 class="context-title">' + escapeHtml(rel.title) + '</h2>' +
      '<p class="context-meta">' + products.length + ' pieces ready to customize</p>';
  }

  function renderTicker(){
    var ticker = document.querySelector('.ticker');
    if (!ticker) return;
    var inner = ticker.querySelector('.ticker-inner');
    if (!inner) return;
    ticker.style.display = '';

    var qty = getQty();
    var amount = getDiscountAmount();
    var subtotal = getSubtotal();
    var saved = amount;

    var headline, sub;
    if (qty === 0) {
      headline = 'Build your set, save more.';
      sub = 'Add any 2 pieces to unlock $5 off · Add more for bigger savings.';
    } else if (qty === 1) {
      headline = '1 piece in your set';
      sub = 'Add 1 more to unlock $5 off.';
    } else if (qty === 2) {
      headline = '2 pieces ready · $5 off applied';
      sub = 'Saving ' + fmtMoney(saved) + ' · Add 1 more for $8';
    } else if (qty === 3) {
      headline = '3 pieces ready · $8 off applied';
      sub = 'Saving ' + fmtMoney(saved) + ' · Add 1 more for $10';
    } else {
      headline = qty + ' pieces ready · $10 off applied';
      sub = 'Saving ' + fmtMoney(saved) + ' · Maximum discount unlocked';
    }

    var tiers = [
      { count: 2, amount: 5, label: 'Set of 2' },
      { count: 3, amount: 8, label: 'Set of 3' },
      { count: 4, amount: 10, label: 'Set of 4+' }
    ];

    var tiersHtml = tiers.map(function(t){
      var unlocked = qty >= t.count;
      var needed = Math.max(0, t.count - qty);
      var status = unlocked
        ? '<div style="font-family:Jost,sans-serif;font-size:9px;color:#C9A84C;font-weight:600;letter-spacing:0.08em;text-transform:uppercase">✓ Unlocked</div>'
        : '<div style="font-family:Jost,sans-serif;font-size:10px;color:#A88838;letter-spacing:0.02em;font-weight:400">Add ' + needed + ' more</div>';
      return '<div style="flex:1;min-width:0;text-align:center;padding:8px 4px;border:1px solid ' + (unlocked ? '#C9A84C' : 'rgba(212,200,224,0.22)') + ';border-radius:6px;background:' + (unlocked ? 'rgba(201,168,76,0.14)' : 'rgba(15,20,55,0.35)') + '">' +
        '<div style="font-family:\'Cormorant Garamond\',Georgia,serif;font-size:20px;color:' + (unlocked ? '#E8D89B' : '#D4C8E0') + ';font-weight:400;line-height:1;font-style:italic">' + '$' + t.amount + '<span style="font-size:13px"> off</span></div>' +
        '<div style="font-family:Jost,sans-serif;font-size:9px;color:' + (unlocked ? '#E8D89B' : '#D4C8E0') + ';margin-top:3px;letter-spacing:0.08em;text-transform:uppercase;font-weight:500">' + t.label + '</div>' +
        '<div style="margin-top:4px">' + status + '</div>' +
      '</div>';
    }).join('<div style="width:6px;flex-shrink:0"></div>');

    inner.innerHTML =
      '<div style="position:relative;max-width:680px;margin:0 auto;padding:10px 16px">' +
        '<div style="text-align:center;margin-bottom:8px">' +
          '<div style="font-family:\'Cormorant Garamond\',Georgia,serif;font-size:15px;color:#E8D89B;font-weight:400;line-height:1.2;letter-spacing:0.02em">' + headline + '</div>' +
          '<div style="font-family:Jost,sans-serif;font-size:11px;color:#D4C8E0;font-weight:300;margin-top:3px;letter-spacing:0.02em">' + sub + '</div>' +
        '</div>' +
        '<div style="display:flex;align-items:stretch;justify-content:center;max-width:480px;margin:0 auto">' + tiersHtml + '</div>' +
      '</div>';
  }

  function renderTray(){
    var tray = document.querySelector('.tray');
    var qty = getQty();
    var amount = getDiscountAmount();
    var subtotal = getSubtotal();
    var saved = amount;
    var now = subtotal - saved;
    if (qty === 0) { tray.classList.remove('show'); return; }
    tray.classList.add('show');
    document.getElementById('trayCountLabel').textContent = qty + ' piece' + (qty === 1 ? '' : 's');
    document.getElementById('trayDiscount').textContent = amount > 0 ? '$' + amount + ' off' : 'no discount yet';
    var wasEl = document.getElementById('trayWas');
    if (amount > 0) wasEl.textContent = fmtMoney(subtotal);
    else wasEl.innerHTML = '&nbsp;';
    document.getElementById('trayNow').textContent = fmtMoney(now);
    var cta = document.getElementById('trayCta');
    if (qty >= 4) { cta.disabled = false; cta.textContent = 'Customize & Checkout →'; }
    else if (qty >= 2) { cta.disabled = false; cta.textContent = (qty === 3 ? 'Add 1 more for $10 · or checkout' : 'Add 1 more for $8 · or checkout'); }
    else { cta.disabled = true; cta.textContent = 'Add ' + (2 - qty) + ' more for $5'; }
    cta.onclick = function(){ if (!cta.disabled) openReviewModal(); };
  }

  function renderCtaBars(){
    var qty = getQty();
    var amount = getDiscountAmount();
    var subtotal = getSubtotal();
    var saved = amount;
    var topBar = document.getElementById('topCtaBar');
    var inlineBar = document.getElementById('inlineCta');
    if (qty >= 2) {
      topBar.classList.add('show');
      inlineBar.classList.add('show');
      document.getElementById('topCtaBarHead').textContent = '$' + amount + ' off · ' + qty + ' pieces ready';
      document.getElementById('topCtaBarSub').textContent = 'Saving ' + fmtMoney(saved);
      document.getElementById('inlineCtaHead').textContent = 'Your set is ready.';
      document.getElementById('inlineCtaSub').textContent = qty + ' pieces · ' + '$' + amount + ' off · saving ' + fmtMoney(saved);
      document.getElementById('topCtaBarBtn').onclick = openReviewModal;
      document.getElementById('inlineCtaBtn').onclick = openReviewModal;
    } else {
      topBar.classList.remove('show');
      inlineBar.classList.remove('show');
    }
  }

  // ===== REVIEW MODAL + REDIRECT FLOW =====
  function flattenSetToPieces(){
    var pieces = [];
    Object.keys(state.set).forEach(function(pid){
      var entry = state.set[pid];
      var prod = DATA.products.find(function(p){ return String(p.id) === pid; });
      if (!prod) return;
      var v = prod.variants.find(function(vr){ return vr.id === entry.variantId; });
      if (!v) return;
      for (var i = 0; i < entry.qty; i++) {
        pieces.push({
          productId: prod.id,
          productHandle: prod.handle,
          productTitle: prod.title,
          variantId: v.id,
          variantTitle: v.title,
          price: v.price,
          image: prod.image,
          hasSizes: !!prod.hasSizes
        });
      }
    });
    return pieces;
  }

  function openReviewModal(){
    if (getQty() < 2) return;
    renderReview();
    document.getElementById('customModal').classList.add('show');
    document.body.style.overflow = 'hidden';
    gaEvent('bundle_review_opened', { set_size: getQty(), discount_amount: getDiscountAmount() });
  }

  function closeReviewModal(){
    document.getElementById('customModal').classList.remove('show');
    document.body.style.overflow = '';
  }

  function renderReview(){
    var sheet = document.getElementById('customSheet');
    var pieces = flattenSetToPieces();
    var qty = pieces.length;
    var amount = getDiscountAmount();
    var subtotal = getSubtotal();
    var saved = amount;
    var total = subtotal - saved;

    var piecesHtml = pieces.map(function(p, idx){
      var sizeNote = p.hasSizes && p.variantTitle && p.variantTitle !== 'Default Title'
        ? '<div style="color:#A88838;font-size:12px;margin-top:3px;font-family:Jost,sans-serif">' + escapeHtml(p.variantTitle) + '</div>'
        : '';
      var imgHtml = p.image
        ? '<img src="' + escapeAttr(p.image) + '" alt="" style="width:60px;height:60px;border-radius:4px;object-fit:cover;flex-shrink:0;background:rgba(212,200,224,0.06)">'
        : '<div style="width:60px;height:60px;background:rgba(212,200,224,0.08);border-radius:4px;flex-shrink:0"></div>';
      return '<div class="review-piece" style="display:flex;gap:14px;align-items:center;padding:14px 0;border-bottom:1px solid rgba(212,200,224,0.08)">' +
        '<div style="font-family:Cormorant Garamond,Georgia,serif;font-size:18px;color:#C9A84C;font-weight:400;width:22px;text-align:center;flex-shrink:0">' + (idx + 1) + '</div>' +
        imgHtml +
        '<div style="flex:1;min-width:0">' +
          '<div style="font-family:Jost,sans-serif;font-size:14px;color:#F4F0F8;font-weight:400;line-height:1.3">' + escapeHtml(p.productTitle) + '</div>' +
          sizeNote +
        '</div>' +
        '<div style="font-family:Jost,sans-serif;font-size:14px;color:#E8D89B;font-weight:500;white-space:nowrap;margin-right:6px">' + fmtMoney(p.price) + '</div>' +
        '<button class="review-remove" data-product-id="' + p.productId + '" type="button" aria-label="Remove this piece" title="Remove" style="background:transparent;border:1px solid rgba(212,200,224,0.3);color:#D4C8E0;width:28px;height:28px;border-radius:50%;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;padding:0;line-height:1;font-family:Jost,sans-serif">×</button>' +
      '</div>';
    }).join('');

    var nextTierMsg = '';
    if (qty === 2) nextTierMsg = '<p style="margin:18px 0 0 0;font-family:Jost,sans-serif;font-size:12px;color:#A88838;text-align:center;font-style:italic">Tip · Add one more piece to bump your discount to $8 off.</p>';
    else if (qty === 3) nextTierMsg = '<p style="margin:18px 0 0 0;font-family:Jost,sans-serif;font-size:12px;color:#A88838;text-align:center;font-style:italic">Tip · Add one more piece to bump your discount to $10 off.</p>';

    sheet.innerHTML =
      '<div style="background:#1A1B2E;padding:18px 24px;border-bottom:1px solid rgba(212,200,224,0.15);display:flex;align-items:center;justify-content:space-between;gap:16px;flex-shrink:0">' +
        '<div style="flex:1;min-width:0">' +
          '<h2 style="font-family:Cormorant Garamond,Georgia,serif;font-size:22px;font-weight:400;margin:0;color:#E8D89B;line-height:1.2">Review your set</h2>' +
          '<div style="font-family:Jost,sans-serif;font-size:13px;color:#E8E1F0;margin-top:4px;font-weight:300">' + qty + ' ' + (qty === 1 ? 'piece' : 'pieces') + ' · ' + '$' + amount + ' off applied at checkout</div>' +
        '</div>' +
        '<button data-action="close" type="button" aria-label="Close" style="background:transparent;border:1px solid #D4C8E0;color:#F4F0F8;width:38px;height:38px;border-radius:50%;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;line-height:1;flex-shrink:0;padding:0;font-family:Jost,sans-serif">×</button>' +
      '</div>' +
      '<div style="flex:1;overflow-y:auto;background:#0F1437;padding:32px 24px;min-height:0">' +
        '<div style="max-width:560px;margin:0 auto">' +
          '<p style="font-family:Jost,sans-serif;font-size:11px;color:#D4C8E0;text-align:center;margin:0 0 22px 0;font-weight:400;letter-spacing:0.12em;text-transform:uppercase">What you are customizing</p>' +
          '<div style="background:rgba(232,225,240,0.03);border:1px solid rgba(168,136,56,0.35);border-radius:6px;padding:6px 22px">' +
            piecesHtml +
          '</div>' +
          nextTierMsg +
          '<div style="background:rgba(232,225,240,0.03);border:1px solid rgba(212,200,224,0.12);border-radius:6px;padding:18px 22px;margin-top:24px;font-family:Jost,sans-serif;font-size:14px;color:#F4F0F8">' +
            '<div style="display:flex;justify-content:space-between;padding:5px 0"><span style="color:#D4C8E0;font-weight:300">Subtotal</span><span>' + fmtMoney(subtotal) + '</span></div>' +
            (saved > 0 ? '<div style="display:flex;justify-content:space-between;padding:5px 0;color:#C9A84C"><span>Discount (' + '$' + amount + ' off)</span><span>– ' + fmtMoney(saved) + '</span></div>' : '') +
            '<div style="display:flex;justify-content:space-between;padding:10px 0 0 0;margin-top:6px;border-top:1px solid rgba(212,200,224,0.12);color:#E8D89B;font-weight:600;font-size:17px"><span>Total</span><span>' + fmtMoney(total) + '</span></div>' +
          '</div>' +
          '<div style="margin:28px 0;padding:22px 24px;background:rgba(201,168,76,0.05);border-radius:6px">' +
            '<h3 style="font-family:Cormorant Garamond,Georgia,serif;font-size:22px;font-weight:300;margin:0 0 10px 0;color:#E8D89B;font-style:italic;line-height:1.2;text-align:center">Next, we will customize each piece.</h3>' +
            '<p style="font-family:Jost,sans-serif;font-size:13px;line-height:1.65;color:#E8E1F0;font-weight:300;margin:0;text-align:center">For each piece, upload your photo and save. We will auto-advance to the next piece, and your discount applies at checkout.</p>' +
          '</div>' +
          '<button data-action="start" type="button" style="display:block;width:100%;background:#C9A84C;color:#0F1437;border:none;padding:18px 32px;border-radius:999px;font-family:Jost,sans-serif;font-size:13px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;cursor:pointer;box-shadow:0 6px 20px rgba(201,168,76,0.3)">Start with piece 1 of ' + qty + ' →</button>' +
          '<button data-action="back" type="button" style="display:block;width:100%;margin-top:14px;background:transparent;color:#D4C8E0;border:1px solid rgba(212,200,224,0.25);padding:14px 32px;border-radius:999px;font-family:Jost,sans-serif;font-size:12px;font-weight:500;letter-spacing:0.06em;cursor:pointer">← Keep editing your set</button>' +
        '</div>' +
      '</div>';

    sheet.querySelector('[data-action="close"]').addEventListener('click', closeReviewModal);
    sheet.querySelector('[data-action="back"]').addEventListener('click', closeReviewModal);
    sheet.querySelector('[data-action="start"]').addEventListener('click', startBundleFlow);

    sheet.querySelectorAll('.review-remove').forEach(function(btn){
      btn.addEventListener('click', function(){
        var pid = btn.getAttribute('data-product-id');
        if (state.set[pid]) {
          state.set[pid].qty -= 1;
          if (state.set[pid].qty <= 0) delete state.set[pid];
        }
        renderAll();
        if (getQty() < 2) { closeReviewModal(); }
        else { renderReview(); }
      });
    });
  }

  function startBundleFlow(){
    var pieces = flattenSetToPieces();
    if (pieces.length < 2) return;
    var amount = getDiscountAmount();
    var subtotal = getSubtotal();
    var bundleSetId = 'set_' + Date.now() + '_' + Math.random().toString(36).slice(2,8);
    var plan = {
      id: bundleSetId,
      createdAt: Date.now(),
      pieces: pieces.map(function(p){
        return { productId: p.productId, productHandle: p.productHandle, productTitle: p.productTitle, variantId: p.variantId, variantTitle: p.variantTitle, price: p.price, image: p.image, done: false };
      }),
      currentIdx: 0,
      discountAmount: amount,
      subtotal: subtotal,
      discountCode: null
    };
    try { sessionStorage.setItem(PLAN_KEY, JSON.stringify(plan)); } catch(e) {}
    gaEvent('bundle_flow_started', { set_size: pieces.length, discount_amount: amount, bundle_set_id: bundleSetId });
    var btn = document.querySelector('#customSheet [data-action="start"]');
    if (btn) { btn.disabled = true; btn.style.opacity = '0.6'; btn.textContent = 'Preparing your first piece...'; }
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .catch(function(){})
      .finally(function(){
        var first = plan.pieces[0];
        window.location.href = '/products/' + encodeURIComponent(first.productHandle) +
          '?variant=' + encodeURIComponent(first.variantId) +
          '&bundle_step=1&bundle_id=' + encodeURIComponent(bundleSetId);
      });
  }

  function attachPillListeners(){
    document.querySelectorAll('.pill').forEach(function(pill){
      pill.onclick = function(){
        document.querySelectorAll('.pill').forEach(function(p){ p.classList.remove('active'); });
        pill.classList.add('active');
        state.activeRel = pill.getAttribute('data-rel');
        state.activeStudio = null;
        renderAll();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
    });
  }

  function renderAll(){
    renderContextBand();
    renderStudioNav();
    renderStudios();
    renderTicker();
    renderTray();
    renderCtaBars();
  }

  function init(){
    try {
      attachPillListeners();
      renderAll();
      gaEvent('bundle_page_view', { total_products: DATA.products.length });
    } catch(e){
      showError('Render failed during init.', (e && e.stack) ? e.stack : String(e));
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.shazoryBundle = { state: state, data: DATA, openReviewModal: openReviewModal, closeReviewModal: closeReviewModal, startBundleFlow: startBundleFlow };
})();
